import * as React from 'react';
import { Link } from 'react-router-dom';
import FilledAptitudeTest from 'src/entities/FilledAptitudeTest';
import MyAccountHeaderComponent from 'src/modules/my-account/partials/MyAccountHeader.component';
import Person from 'src/entities/Person';

export interface TestResultsInvestorTypeComponentProps {
  filledAptitudeTest: FilledAptitudeTest;
  failMessage?: string;
  activeProfile: Person;
  handleClick: () => void;
}

class AptitudeTestResultsInvestorTypeComponent extends React.Component<TestResultsInvestorTypeComponentProps> {

  public render(): React.ReactNode {

    return (
      <section className="cuenta-inversor-section">
        <div className="container">
          <MyAccountHeaderComponent
            pageTitle="Mi cuenta"
            breadcrum="Tipo de inversor"
          />
          <div className="row">
            <div className="col-sm-12">
              <div className="simple-card padding-40">
                <section>
                  <Link to="/mi-cuenta/tipo-de-inversor">
                    <span className="close pointer"/>
                  </Link>
                  <p className="featured c-black-text">
                    <span className="user-circle"/>
                    Acreditate como inversor
                  </p>
                  <div className="gap-5"/>
                  {this.props.filledAptitudeTest.passed ?
                    <section>
                      <p className="featured c-primary f-s-20">
                        ¡Felicidades, has superado el test!
                      </p>
                      <div className="gap-5"/>
                      <p>
                        <strong>
                          Tan solo te quedan dos breves pasos para ser inversor acreditado y poder invertir sin límites
                          en las mejores startups
                        </strong>
                      </p>
                      <div className="gap-20"/>
                      <h4>
                        ADVERTENCIA DE RIESGOS Y NO SUJECIÓN A SUPERVISIÓN
                      </h4>
                      <p>
                        <strong>
                          Advertencia de riesgos al inversor.
                        </strong>
                      </p>
                      <p>
                        Las actividades de inversión en “Startups” o empresas de reciente creación pueden conllevar una
                        serie de riesgos, como pueden ser la falta de liquidez, la falta de ingresos por retorno del
                        capital
                        , el riesgo de dilución de la participación en la sociedad, la no transmisibilidad de las
                        participaciones y riesgo de pérdida del dinero invertido. TCA está destinada a personas con
                        suficientes conocimientos para entender los riesgos que subyacen en este tipo de inversiones en
                        empresas de reciente creación.
                      </p>
                      <p>
                        Las operaciones publicadas en TCA son consideradas como “Startups” o empresas de reciente
                        creación,
                        y
                        por lo tanto esto conlleva a que la inversión realizada se pueda perder. Por lo tanto, se
                        recomienda
                        invertir una cantidad que se esté dispuesto a perder ya que TCA no le reintegrará la inversión
                        realizada. No obstante lo anterior, para que una operación sea admitida en TCA se deben cumplir
                        unos
                        requisitos mínimos que aseguren la estabilidad financiera de la operación. Asimismo
                        cabe advertir que
                        al ser “Startups” o empresas de reciente creación, es difícil que durante los primeros años de
                        inversión se retorne la inversión, incluyendo la posibilidad de ofrecer dividendos, ya que casi
                        siempre, los beneficios se suelen reinvertir en el propio negocio para impulsar el crecimiento
                        porque las empresas no tienen el deber de pagar dividendos a los inversores.
                      </p>
                      <p>
                        <strong>
                          Riesgo de falta de liquidez y transmisibilidad
                        </strong>
                      </p>
                      <p>
                        La liquidez evalúa la facilidad que tiene un activo en convertirse en dinero, y en este caso en
                        concreto sería la facilidad con que se pueden vender las participaciones de una “Startup”
                        después
                        de
                        adquirirlas. Como las participaciones de una “Startup” no cotizan, la posibilidad de transmitir
                        las
                        participaciones es baja o muy baja, lo que supone que la inversión deba considerarse como una
                        inversión a medio plazo, y de escasa liquidez.
                      </p>
                      <p>
                        <strong>
                          Riesgo de dilución
                        </strong>
                      </p>
                      <p>
                        Se advierte a los inversores que cualquier inversión realizada a través de la Plataforma puede
                        estar
                        sujeta a una posible dilución futura. Se produce dilución cuando una empresa crea nuevas
                        participaciones, y los socios que no subscriban las nuevas participaciones emitidas, verán
                        reducida
                        su participación en la empresa de forma proporcional a la ampliación de capital realizada,
                        conllevando una pérdida del valor de la participación.
                      </p>
                      <p>
                        Sin embargo, las empresas pueden ofrecer Participaciones Ordinarias o de “Clase A”, incluyendo
                        derechos de voto y derechos de suscripción preferente, lo que obligaría a la empresa a ofrecer
                        primero a sus socios con Participaciones Ordinarias o de “Clase A” la oportunidad de adquirirlas
                        evitando así el riesgo de dilución para el accionista.
                      </p>
                      <p>
                        <strong>
                          No sujeción a supervisión
                        </strong>
                      </p>
                      <p>
                        TCA le advierte que las plataformas de financiación participativa no ostentan la condición de
                        servicios de inversión, ni entidad de crédito, y por ello no están adheridas a ningún fondo de
                        garantía de inversiones o fondo de garantía de depósitos, con los riesgos que ello conlleva.
                        Como
                        consecuencia de lo anterior, se informa a los usuarios que las operaciones de financiación
                        participativa de TCA no están autorizados ni supervisados por la Comisión Nacional del Mercado
                        de
                        Valores (CNMV) ni por el Banco de España. Esta no sujeción a supervisión viene prevista en el
                        artículo 83 de la Ley 5/2015, de 27 de abril, de fomento de la financiación empresarial.
                      </p>
                      <div className="gap-20"/>
                      <p className="text-center">
                        <button
                          className="btn btn-secondary btn-lg"
                          onClick={() => this.props.handleClick()}
                        >
                          He leído y acepto la advertencia
                        </button>
                      </p>
                    </section> :
                    <div className="row">
                      <div className="text-center col-md-8 col-md-offset-2">
                        <span className="alerted-circle"/>
                        <div className="gap-20"/>
                        <p className="featured c-grey">
                          ¡Lo sentimos no has superado el test!
                        </p>
                        {this.props.failMessage === 'financiero' ?
                          <p>
                            <strong>
                              {this.props.activeProfile.displayName} de acuerdo a la ley 05/2015 no puedes ser inversor
                              acreditado porque no cumples los requisitos económicos mínimos
                            </strong>
                          </p> :
                          <p>
                            <strong>
                              ¡Muchas gracias por haberlo intentado!
                            </strong>
                            <div className="gap-10"/>
                            Si quieres conocer un poco más sobre los riesgos y las oportunidades de invertir en una
                            Startup
                            a través de una plataforma como The Crowd Angel te recomendamos que consultes&nbsp;
                            <strong>
                              <a
                                style={{color: '#3B6E46'}}
                                href="http://blog.thecrowdangel.com/"
                                target="_blank"
                              >
                                nuestro blog
                              </a>
                            </strong>
                          </p>
                        }
                        <div className="gap-20"/>
                      </div>
                    </div>
                  }
                </section>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default AptitudeTestResultsInvestorTypeComponent;


// WEBPACK FOOTER //
// ./src/modules/my-account/investor-types/aptitude-test/AptitudeTestResultsInvestorType.component.tsx